const contacts = [
  {
    social: "email",
    href: "mailto:carlostsa10@gmail.com",
    text: "carlostsa10@gmail.com",
  },
  {
    social: "linkedin",
    href: "https://www.linkedin.com/in/carlostsa/",
    text: "in/carlostsa",
  },
  {
    social: "github",
    href: "https://github.com/carlostsa10",
    text: "/carlostsa10",
  },
];

export default contacts;
